// pages/StaticLiveCheck/index.tsx
import React from 'react';
import { BASEURL } from "@api/baseUrl"
import { Button, Drawer, Space, Input } from "antd"
import { useRef, useState } from "react"
import { useHistory } from "react-router-dom"
import { columnsFn } from "./data"
import ProTable, { ActionType } from "@ant-design/pro-table"
import { checkGetCardOperatorList } from '@api/product';
import { productApi } from '@utils/util';
import { PROCODE_STATICLIVECHECK } from '@utils/enum';
import { ExportButton } from '@components/index';
import { staticFaceCheck } from "@api/product/identityCheck";
import ProForm from "@ant-design/pro-form";
import { UserOutlined, PictureOutlined, LinkOutlined, CodeOutlined } from "@ant-design/icons";
import { ImageUploadPanel } from "@components/MyProduct/Common/ImageUploadPanel";
import {createDefaultConfirmContent, ImageType, useImageCheck} from "@components/MyProduct/Common/useImageCheck";

// 接口请求的 api 层
const getApi = productApi(checkGetCardOperatorList)

export default () => {
    const history = useHistory()
    const formRef = useRef()
    const otherParams = { productCode: PROCODE_STATICLIVECHECK }
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
    const [modalProps, setModalProps] = useState({ visible: false, title: '新增', params: {} })
    const ref = useRef<ActionType>(null);
    const [uploadVisible, setUploadVisible] = useState(false);

    const operate = async (type: any, record: any) => {
        // operate 函数为增删改查需要处理的业务
    }

    const getListApi = async (params: any, sorter: any, filter: any) => {
        const { data } = await getApi({ ...params }, false)
        const { values, total } = data || {}
        return {
            data: values || [],
            success: true,
            total
        }
    }

    const columns = columnsFn(operate)

    const getQueryParams = () => ({
        // @ts-ignore
        ...formRef.current?.getFieldsFormatValue(),
        ...otherParams
    })

    const reFresh = () => {
        // @ts-ignore
        ref.current?.clearSelected()
        ref.current?.reload()
    }

    const OnlineRequest = ({ onOk }: { onOk?: () => void }) => {
        const [form] = ProForm.useForm();
        const [imageType, setImageType] = useState<ImageType>('URL');
        const [imageUrl, setImageUrl] = useState('');

        const {
            fileList,
            loading,
            imagePreview,
            imageInfo,
            customRequest,
            startCheck,
            removeImage,
            formatFileSize,
            imageValid,
        } = useImageCheck({
            request: async (params: any) => {
                console.log(params)
                return staticFaceCheck(params);
            },
            onSuccess: () => {
                onOk?.();
                reFresh();
            },
            successMessage: '提交成功，请稍后刷新页面查看检测结果',
            needName: false,
            needIdNo: false,
            createConfirmContent: createDefaultConfirmContent,
        });

        // 处理图片类型变化
        const handleImageTypeChange = (type: ImageType) => {
            setImageType(type);
            if (type === 'URL') {
                removeImage();
            } else {
                setImageUrl('');
            }
        };

        // 检查是否可以提交
        const isSubmitDisabled = () => {
            if (imageType === 'URL') {
                return !imageUrl || !/^https?:\/\/.+/.test(imageUrl);
            }
            if (imageType === 'BASE64') {
                return !imageValid;
            }
            return true;
        };

        // 自定义提交按钮
        const CustomSubmitter = () => {
            return (
                <div style={{ textAlign: 'center', marginTop: 24 }}>
                    <Button
                        type="primary"
                        size="large"
                        style={{ width: 200 }}
                        onClick={() => startCheck({
                            form,
                            imageType,
                            imageUrl,
                        })}
                        loading={loading}
                        disabled={isSubmitDisabled()}
                    >
                        开始验证
                    </Button>

                    <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
                        {!isSubmitDisabled() ? '信息已准备就绪' : '请填写相关信息'}
                    </div>
                </div>
            );
        };

        return (
            <div style={{ padding: '0 20px' }}>
                <ProForm
                    form={form}
                    layout="horizontal"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                    submitter={{
                        render: () => <CustomSubmitter />
                    }}
                    initialValues={{
                        imageType: 'URL'
                    }}
                >
                    {/* 图片上传/URL输入区域 */}
                    <ProForm.Item
                        label="人像图片"
                        name="image"
                        labelAlign="left"
                        labelCol={{ flex: '80px' }}
                        wrapperCol={{ flex: 1 }}
                        style={{ alignItems: 'flex-start' }}
                        rules={[{ required: true, message: '请提供图片信息' }]}
                        validateStatus={
                            (imageType === 'URL' && imageUrl) || (imageType === 'BASE64' && imageValid)
                                ? 'success'
                                : 'error'
                        }
                        help={
                            imageType === 'URL' && !imageUrl
                                ? '请输入图片URL地址'
                                : imageType === 'BASE64' && !imageValid
                                    ? '请上传有效的人像图片'
                                    : ''
                        }
                    >
                        <ImageUploadPanel
                            fileList={fileList}
                            imagePreview={imagePreview}
                            imageInfo={imageInfo}
                            onUpload={customRequest}
                            onRemove={removeImage}
                            accept="image/*"
                            buttonText="选择图片文件"
                            formatFileSize={formatFileSize}
                            imageType={imageType}
                            onImageTypeChange={handleImageTypeChange}
                            imageUrl={imageUrl}
                            onImageUrlChange={setImageUrl}
                            showImageTypeSelector={true}
                            showImageUrlInput={imageType === 'URL'}
                        />
                    </ProForm.Item>
                </ProForm>

                {/* 使用说明 */}
                <div style={{
                    marginTop: 24,
                    padding: 16,
                    border: '1px solid #e8e8e8',
                    borderRadius: 6,
                    backgroundColor: '#f9f9f9'
                }}>
                    <div style={{ fontWeight: 'bold', marginBottom: 12, color: '#333' }}>
                        使用说明
                    </div>
                    <div style={{ fontSize: 13, lineHeight: 1.8, color: '#666' }}>
                        <div>🔍 <strong>静态活体检测验证模式：</strong></div>
                        <div>1. 输入待检测的姓名信息（可选）</div>
                        <div>2. 选择图片类型：图片路径或上传图片</div>
                        <div>3. <strong>图片路径模式：</strong>输入完整的图片URL地址（需支持公网访问）</div>
                        <div>4. <strong>上传图片模式：</strong>点击”选择图片文件”上传人像照片</div>
                        <div>5. 支持 JPG、PNG、BMP、GIF 格式，单个文件最大 2MB</div>
                        <div>6. 上传后可预览图片信息，可随时移除重新上传</div>
                        <div style={{ marginTop: 12 }}>
                            ⚠️ <strong>重要注意事项：</strong>
                        </div>
                        <div>• 请确保输入的姓名信息准确无误（如提供）</div>
                        <div>• 图片路径模式需确保URL可公开访问</div>
                        <div>• 上传的人像图片应清晰可见，正面免冠</div>
                        <div>• 图片中人脸部分应占据足够比例</div>
                        <div>• 确保图片光线充足，避免过暗或过曝</div>
                        <div>• 避免使用美颜、滤镜处理过的照片</div>
                        <div>• 静态活体检测用于核实照片是否为真人</div>
                        <div>• 提交成功后，检测结果会显示在调用明细中</div>
                        <div>• 可在表格中查看历史记录并导出结果</div>
                        <div>• 该调用会产生一定费用,请确认余额充足</div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <ProTable<any>
                style={{ flex: 1, overflow: 'scroll' }}
                scroll={{ x: 1300 }}
                columns={columns}
                params={otherParams}
                request={getListApi}
                formRef={formRef as any}
                options={{ reload: false, density: false, setting: false }}
                toolbar={{
                    actions: [
                        <ExportButton
                            key="export"
                            type='primary'
                            action={`${BASEURL}/web/product/exportCardOperatorList`}
                            param={getQueryParams}
                            btnText="导出"
                        />,
                        <Button
                            key="online"
                            type="primary"
                            onClick={() => setUploadVisible(true)}
                            style={{ marginLeft: 8 }}
                        >
                            在线验证
                        </Button>,
                    ],
                }}
                rowKey="tiId"
                pagination={{ defaultPageSize: 10, showSizeChanger: true, showQuickJumper: true }}
                actionRef={ref as any}
                search={{
                    optionRender: (searchConfig, formProps, dom) => [...dom.reverse()]
                }}
            />
            <Drawer
                title={
                    <Space>
                        <PictureOutlined />
                        <span style={{ fontSize: 16, fontWeight: 'bold' }}>静态活体检测验证</span>
                    </Space>
                }
                open={uploadVisible}
                width={800}
                onClose={() => {
                    setUploadVisible(false);
                }}
                destroyOnClose
            >
                <OnlineRequest
                    onOk={() => {
                        setUploadVisible(false);
                        setTimeout(() => {
                            reFresh();
                        }, 1000);
                    }}
                />
            </Drawer>
        </>
    );
}